function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";
import { insertAd } from "../../constants";

// Updates an entity cache in response to any action with response.entities.
var investmentItemMentionListItemEntities = function investmentItemMentionListItemEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byInvestmentItemIdInAndAuthUserId: {},
    byPostId: {},
    byPostIdAndInvestmentItemId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_INVESTMENTITEMMENTIONLISTITEMSBYINVESTMENTITEMIDINANDAUTHUSERID_SUCCESS:
      {
        var investmentItemIds = action.investmentItemIds,
          authUserId = action.authUserId,
          rawResponse = action.response,
          sinceId = action.sinceId,
          maxId = action.maxId;
        var investmentItemIdsStr = investmentItemIds.join(",");
        var _key = [investmentItemIdsStr, authUserId].join("-");
        var existingItems = state.byInvestmentItemIdInAndAuthUserId[_key] || [];
        var response = _toConsumableArray(rawResponse);
        var updatedItems;
        if (sinceId !== undefined && existingItems.length > 0) {
          // Upward pagination (prepend)
          updatedItems = _toConsumableArray(response).reverse().concat(existingItems);
        } else if (maxId !== undefined && existingItems.length > 0) {
          // Downward pagination (append w/ ad)
          updatedItems = existingItems.concat(insertAd(response, maxId));
        } else {
          // Initial load
          updatedItems = response;
        }
        var _byPostId = _objectSpread({}, state.byPostId);
        var _byPostIdAndInvestmentItemId = _objectSpread({}, state.byPostIdAndInvestmentItemId);
        response.forEach(function (mentionListItem) {
          if (!mentionListItem.postListItemByPostId) return;
          Object.values(mentionListItem.postListItemByPostId).forEach(function (postListItem) {
            merge(_byPostId, postListItem.investmentItemMentionListItemsByPostId);
            Object.values(postListItem.investmentItemMentionListItemsByPostId).forEach(function (mentionListItems) {
              mentionListItems.forEach(function (mention) {
                var mapKey = [postListItem.postId, mention.investmentItemId].join("-");
                _byPostIdAndInvestmentItemId[mapKey] = mention;
              });
            });
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          byInvestmentItemIdInAndAuthUserId: _objectSpread(_objectSpread({}, state.byInvestmentItemIdInAndAuthUserId), {}, _defineProperty({}, _key, updatedItems)),
          byPostId: _byPostId,
          byPostIdAndInvestmentItemId: _byPostIdAndInvestmentItemId
        });
      }
    case ActionTypes.GET_HASHTAGVIEWBYHASHTAGTEXTANDAUTHUSERID_SUCCESS:
      var byPostId = _objectSpread({}, state.byPostId);
      var byPostIdAndInvestmentItemId = _objectSpread({}, state.byPostIdAndInvestmentItemId);
      var hashtagId = action.response.hashtagId;
      var key = [hashtagId, action.authUserId].join("-");
      action.response.hashtagMentionListItemsByHashtagMentionHashtagIdAndAuthUserId[key].forEach(function (mentionListItem) {
        return mentionListItem.postListItemByPostId && Object.values(mentionListItem.postListItemByPostId).forEach(function (postListItem) {
          merge(byPostId, postListItem.investmentItemMentionListItemsByPostId);
          Object.values(postListItem.investmentItemMentionListItemsByPostId).forEach(function (mentionListItems) {
            return mentionListItems.forEach(function (mentionListItem) {
              var key = [postListItem.postId, mentionListItem.investmentItemId].join("-");
              byPostIdAndInvestmentItemId[key] = mentionListItem;
            });
          });
        });
      });
      return merge({}, state, {
        byPostId: byPostId,
        byPostIdAndInvestmentItemId: byPostIdAndInvestmentItemId
      });
    case ActionTypes.GET_BROKERMENTIONLISTITEMSBYBROKERMENTIONBROKERIDANDAUTHUSERID_SUCCESS:
    case ActionTypes.GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_SUCCESS:
    // case ActionTypes.GET_INVESTMENTITEMMENTIONLISTITEMSBYINVESTMENTITEMIDINANDAUTHUSERID_SUCCESS:
    case ActionTypes.GET_USERMENTIONLISTITEMSBYUSERMENTIONUSERIDANDAUTHUSERID_SUCCESS:
    case ActionTypes.GET_HASHTAGMENTIONLISTITEMSBYHASHTAGMENTIONHASHTAGID_SUCCESS:
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byPostId = _objectSpread({}, state.byPostId);
      var byPostIdAndInvestmentItemId = _objectSpread({}, state.byPostIdAndInvestmentItemId);
      action.response.forEach(function (mentionListItem) {
        mentionListItem.postListItemByPostId && Object.values(mentionListItem.postListItemByPostId).forEach(function (postListItem) {
          merge(byPostId, postListItem.investmentItemMentionListItemsByPostId);
          Object.values(postListItem.investmentItemMentionListItemsByPostId).forEach(function (mentionListItems) {
            return mentionListItems.forEach(function (mentionListItem) {
              var key = [postListItem.postId, mentionListItem.investmentItemId].join("-");
              byPostIdAndInvestmentItemId[key] = mentionListItem;
            });
          });
        });
      });
      return Object.assign({}, state, {
        byPostId: byPostId,
        byPostIdAndInvestmentItemId: byPostIdAndInvestmentItemId
      });
    case ActionTypes.GET_BOOKMARKLISTITEMSBYUSERID_SUCCESS:
      var byPostId = _objectSpread({}, state.byPostId);
      var byPostIdAndInvestmentItemId = _objectSpread({}, state.byPostIdAndInvestmentItemId);
      action.response.forEach(function (bookmarkListItem) {
        return bookmarkListItem.postListItemByPostBookmarksId && Object.values(bookmarkListItem.postListItemByPostBookmarksId).forEach(function (postListItem) {
          merge(byPostId, postListItem.investmentItemMentionListItemsByPostId);
          Object.values(postListItem.investmentItemMentionListItemsByPostId).forEach(function (mentionListItems) {
            return mentionListItems.forEach(function (mentionListItem) {
              var key = [postListItem.postId, mentionListItem.investmentItemId].join("-");
              byPostIdAndInvestmentItemId[key] = mentionListItem;
            });
          });
        });
      });
      return Object.assign({}, state, {
        byPostId: byPostId,
        byPostIdAndInvestmentItemId: byPostIdAndInvestmentItemId
      });
    case ActionTypes.GET_POSTLISTITEMBYPOSTIDANDAUTHUSERID_SUCCESS:
      return merge({}, state, {
        byPostId: action.response.investmentItemMentionListItemsByPostId
      });
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byPostId = _objectSpread({}, state.byPostId);
      var byPostIdAndInvestmentItemId = _objectSpread({}, state.byPostIdAndInvestmentItemId);
      action.response.forEach(function (eventListItem) {
        return eventListItem.postListItemByPostId && Object.values(eventListItem.postListItemByPostId).forEach(function (postListItem) {
          merge(byPostId, postListItem.investmentItemMentionListItemsByPostId);
          Object.values(postListItem.investmentItemMentionListItemsByPostId).forEach(function (mentionListItems) {
            return mentionListItems.forEach(function (mentionListItem) {
              var key = [postListItem.postId, mentionListItem.investmentItemId].join("-");
              byPostIdAndInvestmentItemId[key] = mentionListItem;
            });
          });
        });
      });
      return Object.assign({}, state, {
        byPostId: byPostId,
        byPostIdAndInvestmentItemId: byPostIdAndInvestmentItemId
      });
    case ActionTypes.GET_POSTLISTITEMSBYPOSTUSERIDNOTANDPOSTPARENTISNULLANDPOSTEVENTISNULLANDPOSTGEOLOCATIONCOUNTRYIDIN_SUCCESS:
    case ActionTypes.GET_POSTLISTITEMSBYPOSTUSERIDANDAUTHUSERID_SUCCESS:
      var byPostId = _objectSpread({}, state.byPostId);
      var byPostIdAndInvestmentItemId = _objectSpread({}, state.byPostIdAndInvestmentItemId);
      action.response.forEach(function (postListItem) {
        merge(byPostId, postListItem.investmentItemMentionListItemsByPostId);
        Object.values(postListItem.investmentItemMentionListItemsByPostId).forEach(function (mentionListItems) {
          return mentionListItems.forEach(function (mentionListItem) {
            var key = [postListItem.postId, mentionListItem.investmentItemId].join("-");
            byPostIdAndInvestmentItemId[key] = mentionListItem;
          });
        });
      });
      return Object.assign({}, state, {
        byPostId: byPostId,
        byPostIdAndInvestmentItemId: byPostIdAndInvestmentItemId
      });
    default:
      return state;
  }
};
export default investmentItemMentionListItemEntities;